import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b90cc3e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b90cc3e')) {
      api.createRecord('1b90cc3e', component.options)
    } else {
      api.reload('1b90cc3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1b90cc3e", function () {
      api.rerender('1b90cc3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/order_manage_new/index.vue"
export default component.exports